// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"a2fc0d67","496":"7cbc4e8d"}[chunkId] + ".chunk.css";
};